import { Text } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { ReactNode } from 'react';
import { useRecoilValue } from 'recoil';

import { homeGlobalState } from '../../store/home/capture/atom';

export const useWithValueVisibility = () => {
  const { valueVisibility } = useRecoilValue(homeGlobalState);

  return (component: ReactNode): ReactNode =>
    valueVisibility ? (
      component
    ) : (
      <Text fontSize="xs" letterSpacing={Typography['bullet.spacing']}>
        {Typography['bullet.sequence']}
      </Text>
    );
};
